export function ContactSection() {
  return (
    <section id="contact" className="py-10 md:py-14 bg-accent-50/60">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">联系我们</h2>
        <p className="mt-2 text-sm text-foreground-600">有好的韩漫资源或建议？欢迎联系我们投稿与交流</p>
        <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-4">
          <div className="flex items-center gap-2 px-5 py-3 rounded-full bg-background-50 text-foreground-700">
            <i className="ri-mail-line text-primary-500 text-lg"></i>
            <span className="text-sm">contact@hanmanwu.com</span>
          </div>
          <div className="flex items-center gap-2 px-5 py-3 rounded-full bg-background-50 text-foreground-700">
            <i className="ri-wechat-line text-accent-500 text-lg"></i>
            <span className="text-sm">微信公众号：韩漫屋追更</span>
          </div>
          <div className="flex items-center gap-2 px-5 py-3 rounded-full bg-background-50 text-foreground-700">
            <i className="ri-qq-line text-secondary-500 text-lg"></i>
            <span className="text-sm">QQ群：8088088</span>
          </div>
        </div>
      </div>
    </section>
  );
}

const topics = [
  { label: '恋爱甜宠', count: '1,286部', icon: 'ri-heart-line', color: 'text-primary-500', bg: 'bg-primary-100' },
  { label: '奇幻冒险', count: '958部', icon: 'ri-magic-line', color: 'text-accent-500', bg: 'bg-accent-100' },
  { label: '异世穿越', count: '873部', icon: 'ri-rocket-line', color: 'text-primary-500', bg: 'bg-primary-100' },
  { label: '复仇逆袭', count: '742部', icon: 'ri-sword-line', color: 'text-accent-500', bg: 'bg-accent-100' },
  { label: '校园青春', count: '1,102部', icon: 'ri-school-line', color: 'text-primary-500', bg: 'bg-primary-100' },
  { label: '悬疑推理', count: '617部', icon: 'ri-search-eye-line', color: 'text-accent-500', bg: 'bg-accent-100' },
  { label: 'BL纯爱', count: '1,456部', icon: 'ri-heart-2-line', color: 'text-primary-500', bg: 'bg-primary-100' },
  { label: '动作热血', count: '831部', icon: 'ri-fire-line', color: 'text-accent-500', bg: 'bg-accent-100' },
  { label: '都市职场', count: '584部', icon: 'ri-building-line', color: 'text-primary-500', bg: 'bg-primary-100' },
];

export function TopicsSection() {
  return (
    <section id="topics" className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">话题标签</h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">按题材快速筛选你感兴趣的韩漫类型</p>
        <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
          {topics.map((topic) => (
            <a
              key={topic.label}
              href="#index"
              onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="flex items-center gap-3 p-3 rounded-xl bg-background-100 hover:bg-background-200 transition-colors cursor-pointer no-underline group"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${topic.bg} flex-shrink-0`}>
                <i className={`${topic.icon} ${topic.color} text-lg`}></i>
              </div>
              <div className="min-w-0">
                <span className="block text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">{topic.label}</span>
                <span className="text-xs text-foreground-500">{topic.count}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

const rankingItems = [
  {
    rank: 1,
    title: '我的野蛮王妃',
    subtitle: '宫廷恋爱 · 穿越',
    tag: '今日更新第128话',
    tagColor: 'text-primary-600 bg-primary-100',
    icon: 'ri-award-line',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20royal%20palace%20scenery%20with%20soft%20watercolor%20style%2C%20Korean%20manhwa%20aesthetic%2C%20romantic%20historical%20setting%2C%20warm%20golden%20and%20rose%20tones%2C%20detailed%20architectural%20elements%2C%20dreamy%20atmosphere&width=400&height=280&seq=ranking-01&orientation=landscape',
  },
  {
    rank: 2,
    title: '公爵的契约未婚妻',
    subtitle: '西方罗曼史 · 奇幻',
    tag: '热度 98.7万',
    tagColor: 'text-accent-700 bg-accent-100',
    icon: 'ri-heart-pulse-line',
    img: 'https://readdy.ai/api/search-image?query=European%20aristocratic%20ballroom%20scene%20illustration%2C%20Korean%20manhwa%20art%20style%2C%20elegant%20dresses%20and%20suits%2C%20warm%20candlelight%20ambiance%2C%20soft%20gold%20and%20cream%20tones%2C%20romantic%20atmosphere%2C%20high%20detail&width=400&height=280&seq=ranking-02&orientation=landscape',
  },
  {
    rank: 3,
    title: '我独自升级',
    subtitle: '动作冒险 · 奇幻',
    tag: '今日更新第179话',
    tagColor: 'text-primary-600 bg-primary-100',
    icon: 'ri-sword-line',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20scene%20with%20movement%20lines%2C%20Korean%20manhwa%20style%20illustration%2C%20dramatic%20lighting%20from%20above%2C%20warm%20coral%20and%20dark%20charcoal%20palette%2C%20energy%20burst%20effects%2C%20powerful%20composition%2C%20high%20contrast&width=400&height=280&seq=ranking-03&orientation=landscape',
  },
  {
    rank: 4,
    title: '女神降临',
    subtitle: '校园青春 · 美妆',
    tag: '热度 86.3万',
    tagColor: 'text-accent-700 bg-accent-100',
    icon: 'ri-star-line',
    img: 'https://readdy.ai/api/search-image?query=Korean%20high%20school%20campus%20scene%20with%20cherry%20blossoms%2C%20manhwa%20art%20style%2C%20trendy%20fashion%20students%2C%20soft%20pink%20and%20coral%20tones%2C%20spring%20atmosphere%2C%20beautiful%20lighting%2C%20romantic%20slice%20of%20life%20aesthetic&width=400&height=280&seq=ranking-04&orientation=landscape',
  },
  {
    rank: 5,
    title: '重生之都市修仙',
    subtitle: '都市奇幻 · 修仙',
    tag: '今日更新第203话',
    tagColor: 'text-primary-600 bg-primary-100',
    icon: 'ri-rocket-line',
    img: 'https://readdy.ai/api/search-image?query=Modern%20urban%20cityscape%20at%20sunset%20with%20neon%20accents%2C%20Korean%20manhwa%20art%20style%2C%20dynamic%20composition%2C%20young%20characters%20on%20rooftop%2C%20warm%20amber%20and%20deep%20teal%20tones%2C%20cinematic%20lighting%2C%20fantasy%20elements&width=400&height=280&seq=ranking-05&orientation=landscape',
  },
];

export function RankingSection() {
  return (
    <section id="ranking" className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">热度榜单</h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">本周最受追更读者关注的韩漫作品排行</p>
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {rankingItems.slice(0, 3).map((item) => (
            <div key={item.rank} className="flex gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70">
              <div className="relative w-24 h-32 flex-shrink-0 rounded-lg overflow-hidden bg-background-200">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover" />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <div className="flex items-center gap-2">
                    <span className={`w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold ${item.rank === 1 ? 'bg-accent-500 text-background-50' : item.rank === 2 ? 'bg-secondary-500 text-background-50' : 'bg-secondary-300 text-foreground-700'}`}>
                      {item.rank}
                    </span>
                    <h3 className="text-sm font-semibold text-foreground-900 truncate">{item.title}</h3>
                  </div>
                  <p className="mt-1 text-xs text-foreground-500">{item.subtitle}</p>
                </div>
                <span className={`inline-block px-2 py-1 rounded-full text-xs font-medium ${item.tagColor}`}>
                  {item.tag}
                </span>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
          {rankingItems.slice(3).map((item) => (
            <div key={item.rank} className="flex items-center gap-3 p-3 rounded-xl bg-background-50 border border-background-200/70">
              <span className={`w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold ${item.rank === 4 ? 'bg-secondary-300 text-foreground-700' : 'bg-secondary-200 text-foreground-600'}`}>
                {item.rank}
              </span>
              <div className="w-10 h-10 flex-shrink-0 rounded-md overflow-hidden bg-background-200">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 truncate">{item.title}</h3>
                <p className="text-xs text-foreground-500">{item.subtitle}</p>
              </div>
              <span className={`whitespace-nowrap px-2 py-1 rounded-full text-xs font-medium ${item.tagColor}`}>
                {item.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const updates = [
  { title: '《我的野蛮王妃》第128话', time: '10分钟前', type: '更新', typeColor: 'bg-primary-100 text-primary-700' },
  { title: '《公爵的契约未婚妻》第95话', time: '22分钟前', type: '更新', typeColor: 'bg-primary-100 text-primary-700' },
  { title: '《我独自升级》第179话', time: '35分钟前', type: '更新', typeColor: 'bg-primary-100 text-primary-700' },
  { title: '《女神降临》第156话', time: '48分钟前', type: '更新', typeColor: 'bg-primary-100 text-primary-700' },
  { title: '《重生之都市修仙》第203话', time: '1小时前', type: '更新', typeColor: 'bg-primary-100 text-primary-700' },
  { title: '《恶女的谎言》新连载上线', time: '1小时前', type: '新作', typeColor: 'bg-accent-100 text-accent-700' },
  { title: '《深渊之花》第67话', time: '2小时前', type: '更新', typeColor: 'bg-primary-100 text-primary-700' },
  { title: '《皇室的秘密》第42话', time: '2小时前', type: '更新', typeColor: 'bg-primary-100 text-primary-700' },
  { title: '《剑与魔法学院》第88话', time: '3小时前', type: '更新', typeColor: 'bg-primary-100 text-primary-700' },
];

export function UpdatesSection() {
  return (
    <section id="updates" className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">最新更新</h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">实时追踪韩漫最新章节，第一时间获取更新提醒</p>
        <div className="mt-6 space-y-2">
          {updates.map((item, idx) => (
            <div key={idx} className="flex items-center gap-4 px-4 py-3 rounded-xl bg-background-100 border border-background-200/50 hover:border-primary-200/50 transition-colors cursor-pointer group">
              <span className={`whitespace-nowrap px-2 py-1 rounded-full text-xs font-medium ${item.typeColor}`}>
                {item.type}
              </span>
              <span className="flex-1 text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors truncate">
                {item.title}
              </span>
              <span className="whitespace-nowrap text-xs text-foreground-500">{item.time}</span>
              <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
            </div>
          ))}
        </div>
        <div className="mt-5 text-center">
          <span className="inline-flex items-center gap-1 text-sm text-foreground-500">
            <i className="ri-refresh-line"></i>
            数据每5分钟自动刷新 · 共追踪 2,000+ 部韩漫
          </span>
        </div>
      </div>
    </section>
  );
}